<template>
  <div>
    <v-row>
      <v-col md="9">
      </v-col>
      <v-col md="3">
        <v-text-field
          v-model="search"
          class="mt-n8 pr-4 mb-2"
          clearable
          @click:clear="clearSearch"
          @keydown.enter="doSearch"
          prepend-icon="$sl-search"
          placeholder="Sök i listan"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <NotesList 
      :refresh="refresh" 
      :search="searchcriteria"
      is-company-note
    />
    
    <NotesEditModal v-model="notesModal" is-company-note @saved="refresh=!refresh"/>

    <v-btn data-cy="add-new-note" absolute bottom right fab @click="notesModal=true" :disabled="!canCreateNotes">
      <v-icon class="ml-1">$sl-add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import NotesEditModal from '@/components/NotesEditModal.vue'
import NotesList from '@/components/NotesList.vue'
import { CanIDo } from '@/components/mixins'

export default {
  name: 'CompanyNotes',

  mixins: [CanIDo],

  props: {
    reRender: {
      type: Boolean,
      default: false
    }
  },

  components: {
    NotesEditModal,
    NotesList
  },
  
  data: () => ({
    searchcriteria: null,
    search: '',
    refresh: false,
    notesModal: false
  }),

  watch: {
    reRender: {
      handler(value) {
        this.refresh = value
      },
      immediate: true
    }
  },

  asyncComputed: {
    canCreateNotes(){
      return this.canIDo('notes', 'create');
    },
  },

  methods: {
    clearSearch(e) {
      this.searchcriteria = null
      return false
    },

    doSearch(e) {
      e.preventDefault()
      this.searchcriteria = this.search
    }
  }

}
</script>

<style>
</style>